import { MinusCircleOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { FC, useEffect, useState } from "react";
import dayjs from "dayjs";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import ConfirmModals from "../../../../utils/confirmModals";

interface ResubmissionProcedureCghsProps {
  resubmissionProcedure: any;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  patientDetails: IFetchAllDetails | null;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  setIsModalOpen: CallableFunction;
  isModalOpen: boolean;
  handleOk: CallableFunction;
  handleCancel: () => void;
  form: any;
}

const ResubmissionProcedureCghs: FC<ResubmissionProcedureCghsProps> = (
  props
) => {
  const containerStyle =
    props?.resubmissionProcedure?.length > 0
      ? {
          border: "1px solid #D9D9D9",
          borderRadius: "16px",
          padding: "10px 20px",
          marginBottom: "0.8rem",
          width: "100%",
          background: "#E5F3F3",
        }
      : {}; // Empty object when condition is false
  const [procedureForm] = Form.useForm();
  const dateFormat = "DD-MM-YYYY HH:mm:ss";
  const [deletionData, setDeletionData] = useState({
    procedure: {},
    remove: null as ((index: number | number[]) => void) | null,
    nameToRemove: null as number | null,
  });
  const [totalProcedureAmount, setTotalProcedureAmount] = useState<any>();
  const items = Form.useWatch("items", props?.form);
  const proceduresOfResubmission = Form.useWatch("items", procedureForm);

  useEffect(() => {
    if (
      props?.resubmissionProcedure &&
      props.resubmissionProcedure.length > 0
    ) {
      procedureForm.setFieldsValue({
        items: props.resubmissionProcedure,
      });
    }
  }, [props.resubmissionProcedure, procedureForm]);

  useEffect(() => {
    const calculateTotal = (data: any[]) => {
      return data?.reduce((sum: number, procedure: any) => {
        const amount = procedure?.unspecifiedProcedureAmount
          ? parseFloat(procedure?.unspecifiedProcedureAmount || "0") *
            parseFloat(procedure?.numberOfDays)
          : parseFloat(procedure?.procedureAmount || "0") *
            parseFloat(procedure?.numberOfDays);
        return sum + (isNaN(amount) ? 0 : amount);
      }, 0);
    };

    let total = 0;

    if (Array.isArray(items) && items.length > 0) {
      total += calculateTotal(items);
    }

    if (
      Array.isArray(proceduresOfResubmission) &&
      proceduresOfResubmission.length > 0
    ) {
      total += calculateTotal(proceduresOfResubmission);
    }

    setTotalProcedureAmount(total);
  }, [props?.form, items, proceduresOfResubmission]);
  const handleConfirm = async () => {
    await props?.handleOk(deletionData?.procedure);
    if (deletionData.remove && deletionData.nameToRemove !== null) {
      deletionData.remove(deletionData.nameToRemove);
    }
  };

  return (
    <div
      style={{ padding: "14px", height: "110vh", overflow: "auto" }}
      className="Deepak enhancement-procedures-modal"
    >
      <Form form={procedureForm} layout="vertical">
        <Form.List name="items">
          {(fields, { remove }) => (
            <div className="fetchedProcedureList" style={containerStyle}>
              {fields?.map(({ key, name, ...restField }, index) => (
                <Row
                  key={key}
                  gutter={[16, 16]}
                  align="top"
                  style={{
                    border: "1px solid #C4C4C4",
                    padding: "10px 20px",
                    borderRadius: "16px",
                    marginBottom:
                      procedureForm.getFieldValue("items")?.length - 1 !== index
                        ? "0.8rem"
                        : 0,
                    background: "white",
                  }}
                >
                  {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                  "CGHS" ? (
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        label="PROCEDURE REFERRAL"
                        name={[name, "procedureReferral"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <Input disabled={true} style={{ color: "black" }} />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="Procedure"
                      name={[name, "procedureName"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input disabled={true} style={{ color: "black" }} />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item
                      {...restField}
                      label="Procedure Code"
                      name={[name, "externalProcedureCode"]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        style={{ borderRadius: "5px", color: "black" }}
                        placeholder="Enter Procedure Code"
                        disabled={true}
                      />
                    </Form.Item>
                  </Col>

                  {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                  "CAPF" ? (
                    <Col span={7}></Col>
                  ) : (
                    <></>
                  )}

                  <Col span={1}>
                    <Button
                      type="text"
                      style={{ color: "red", padding: "0" }}
                      icon={<MinusCircleOutlined />}
                      onClick={async () => {
                        const currentProcedureList =
                          procedureForm.getFieldValue("items");
                        const procedureToDelete = {
                          ...currentProcedureList[index],
                        };

                        props?.setIsModalOpen(true);

                        setDeletionData({
                          procedure: procedureToDelete,
                          remove: remove,
                          nameToRemove: name,
                        });
                      }}
                    />
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="QUANTITY/NO OF DAYS"
                      name={[name, "numberOfDays"]}
                      rules={[{ required: true, message: "Required" }]}
                    >
                      <Input
                        disabled={true}
                        placeholder="Enter QUANTITY/NO OF DAYS"
                        style={{ borderRadius: "5px", color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="ACCREDITATION STATUS"
                      name={[name, "accreditationStatus"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled={true}
                        style={{ borderRadius: "5px", color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={7}>
                    <Form.Item
                      {...restField}
                      label="TREATING DOCTOR"
                      name={[name, "treatingDoctor"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <Input
                        disabled={true}
                        style={{ borderRadius: "5px", color: "black" }}
                      />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      {...restField}
                      label="TREATMENT START DATE"
                      name={[name, "treatmentStartDate"]}
                      rules={[{ required: true, message: "Required" }]}
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <Input disabled={true} />
                    </Form.Item>
                  </Col>

                  {!procedureForm
                    .getFieldValue(["items", index, "procedureName"])
                    ?.toLowerCase()
                    ?.includes("unspecified") ? (
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        label="AMOUNT"
                        name={[name, "procedureAmount"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Amount"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  {procedureForm
                    .getFieldValue(["items", index, "procedureName"])
                    ?.toLowerCase()
                    ?.includes("unspecified") ? (
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        label="PROCEDURE NAME"
                        name={[name, "unspecifiedProcedureName"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Procedure Name"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  {procedureForm
                    .getFieldValue(["items", index, "procedureName"])
                    ?.toLowerCase()
                    ?.includes("unspecified") ? (
                    <Col span={7}>
                      <Form.Item
                        {...restField}
                        label="PROCEDURE AMOUNT"
                        name={[name, "unspecifiedProcedureAmount"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Procedure Amount"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  {props?.resubmissionProcedure?.[index]?.strats
                    ?.toLowerCase()
                    ?.includes("y") ? (
                    <Col span={7}>
                      <Form.Item
                        {...restField}
                        label="STRATS NAME"
                        name={[name, "stratsName"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Strats Name"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  {props?.resubmissionProcedure?.[index]?.strats
                    ?.toLowerCase()
                    ?.includes("y") ? (
                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        label="STRATS OPTIONS"
                        name={[name, "stratOptionValue"]}
                        rules={[{ required: true, message: "Required" }]}
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Input
                          style={{ borderRadius: "5px", color: "black" }}
                          placeholder="Enter Strats Option"
                          disabled={true}
                        />
                      </Form.Item>
                    </Col>
                  ) : (
                    <></>
                  )}

                  <div style={{ width: "100%" }}>
                    <h4 style={{ display: "flex", justifyContent: "end" }}>
                      Amount: ₹{" "}
                      {!props?.resubmissionProcedure[index]?.procedureName
                        ?.toLowerCase()
                        ?.includes("unspecified")
                        ? parseFloat(
                            props?.resubmissionProcedure[index]?.numberOfDays
                          ) *
                          parseFloat(
                            props?.resubmissionProcedure[index]?.procedureAmount
                          )
                        : parseFloat(
                            props?.resubmissionProcedure[index]?.numberOfDays
                          ) *
                          parseFloat(
                            props?.resubmissionProcedure[index]
                              ?.unspecifiedProcedureAmount
                          )}
                      /-
                    </h4>
                  </div>
                </Row>
              ))}
            </div>
          )}
        </Form.List>
      </Form>

      <div className="procedureList">
        <Form
          form={props?.form}
          labelAlign="left"
          labelWrap
          labelCol={{
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 8 },
            lg: { span: 6 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 12 },
            md: { span: 16 },
            lg: { span: 18 },
          }}
          style={{ width: "100%" }}
        >
          <Form.List name="items">
            {(fields, { add, remove }) => (
              <div
                style={{
                  border:
                    Array.isArray(fields) && fields?.length > 0
                      ? "1px solid #D9D9D9"
                      : "none",
                  borderRadius: "16px",
                  padding: "10px 20px",
                  marginBottom: "0.8rem",
                  width: "100%",
                }}
              >
                {Array.isArray(fields) &&
                  fields?.map((field, index) => {
                    return (
                      <Row
                        key={field.key}
                        gutter={[16, 16]}
                        align="top"
                        style={{
                          border: "1px solid #C4C4C4",
                          padding: "10px 20px",
                          borderRadius: "16px",
                          marginBottom: "0.8rem",
                        }}
                      >
                        {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "CGHS" ? (
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              label="PROCEDURE REFERRAL"
                              name={[field.name, "procedureReferral"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Select
                                showSearch
                                defaultValue={`Select a Procedure Referral`}
                                options={props?.formattedProcedureReferral}
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="Procedure"
                            name={[field.name, "procedureCode"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Procedure`}
                              options={props?.formattedProceduresOptions}
                              onChange={async (value) => {
                                const externalProcedureCode =
                                  JSON.parse(value).externalProcedureCode;
                                const accreditationStatus =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "accreditationStatus",
                                  ]);

                                props?.form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      externalProcedureCode,
                                    },
                                  },
                                });
                                const formData = {
                                  procedureId: externalProcedureCode,
                                  ward:
                                    props?.patientDetails?.patientResponse
                                      ?.cardCategory || "Semi Private",
                                  isNabl:
                                    props?.patientDetails?.casesResponse
                                      ?.nabhStatus ||
                                    props?.patientDetails?.casesResponse
                                      ?.nablStatus,
                                };

                                let result;
                                let finalIsNablUsed = formData.isNabl;

                                try {
                                  result =
                                    await props?.handleGetProcedureAmount(
                                      formData
                                    );

                                  const hasValidAmount =
                                    result?.nabhPackageAmount;
                                } catch (err) {}

                                const amount = !finalIsNablUsed
                                  ? result?.nonNabhPackageAmount
                                  : result?.nabhPackageAmount;

                                const numberOfDays = props?.form.getFieldValue([
                                  "items",
                                  index,
                                  "numberOfDays",
                                ]);

                                props?.form.setFieldsValue({
                                  items: {
                                    [index]: {
                                      procedureAmount: amount,
                                      procedureTotalAmount:
                                        parseFloat(numberOfDays ?? 0) *
                                        parseFloat(amount ?? 0),
                                    },
                                  },
                                });

                                if (
                                  value &&
                                  JSON.parse(value)
                                    ?.strats?.toLowerCase()
                                    ?.includes("y")
                                ) {
                                  const stratsFormData = {
                                    procedureId: JSON.parse(value)?.id,
                                  };

                                  const res =
                                    await props?.handleGetProcedureStrats(
                                      stratsFormData
                                    );
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        stratsName: res?.stratsName,
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            label="Procedure Code"
                            name={[field.name, "externalProcedureCode"]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Input
                              style={{ borderRadius: "5px" }}
                              placeholder="Enter Procedure Code"
                              disabled={true}
                            />
                          </Form.Item>
                        </Col>

                        {props?.patientDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "CAPF" ? (
                          <Col span={7}></Col>
                        ) : (
                          <></>
                        )}

                        <Col span={1}>
                          {fields.length > 0 && (
                            <Button
                              type="text"
                              style={{ color: "red", padding: "0" }}
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(field.name)}
                            />
                          )}
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="QUANTITY/NO OF DAYS"
                            name={[field.name, "numberOfDays"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Input
                              style={{ borderRadius: "5px" }}
                              placeholder="Enter QUANTITY/NO OF DAYS"
                              onChange={(e) => {
                                const numberOfDays = e.target.value.trim();
                                const amount = props?.form
                                  .getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ])
                                  ?.toLowerCase()
                                  ?.includes("unspecified")
                                  ? props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "unspecifiedProcedureAmount",
                                    ])
                                  : props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "procedureAmount",
                                    ]);

                                if (numberOfDays && amount) {
                                  const procedureAmount =
                                    parseFloat(numberOfDays) *
                                    parseFloat(amount);
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        procedureTotalAmount:
                                          procedureAmount?.toString(),
                                      },
                                    },
                                  });
                                } else {
                                  props?.form.setFieldsValue({
                                    items: {
                                      [index]: {
                                        procedureTotalAmount: 0,
                                      },
                                    },
                                  });
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="ACCREDITATION STATUS"
                            name={[field.name, "accreditationStatus"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Accreditation Status`}
                              options={props?.formattedAccreditationOptions}
                              onChange={async (value) => {
                                const externalProcedureCode =
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "externalProcedureCode",
                                  ]);
                                const formData = {
                                  procedureId: externalProcedureCode,
                                  ward: props?.patientDetails?.patientResponse
                                    ?.cardCategory,
                                  isNabl:
                                    props?.patientDetails?.casesResponse
                                      ?.nabhStatus ||
                                    props?.patientDetails?.casesResponse
                                      ?.nablStatus,
                                };
                              }}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={7}>
                          <Form.Item
                            {...field}
                            label="TREATING DOCTOR"
                            name={[field.name, "treatingDoctor"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <Select
                              showSearch
                              defaultValue={`Select a Treating Doctor`}
                              options={props?.formattedTreatingDoctorsOptions}
                            />
                          </Form.Item>
                        </Col>

                        <Col span={8}>
                          <Form.Item
                            {...field}
                            label="TREATMENT START DATE"
                            name={[field.name, "treatmentStartDate"]}
                            rules={[{ required: true, message: "Required" }]}
                            labelCol={{ span: 24 }}
                            wrapperCol={{ span: 24 }}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "100%",
                            }}
                          >
                            <DatePicker
                              showTime
                              format={dateFormat}
                              style={{ width: "100%", borderRadius: "5px" }}
                              allowClear={true}
                              inputReadOnly={false}
                            />
                          </Form.Item>
                        </Col>

                        {!props?.form
                          .getFieldValue(["items", index, "procedureCode"])
                          ?.toLowerCase()
                          ?.includes("unspecified") ? (
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              label="AMOUNT"
                              name={[field.name, "procedureAmount"]}
                              rules={[
                                { required: true, message: "Required" },
                                {
                                  pattern: /^\d+$/,
                                  message: "Only Numeric values are allowed!",
                                },
                              ]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{ borderRadius: "5px" }}
                                placeholder="Enter Amount"
                                onChange={(e) => {
                                  const amount = e.target.value.trim();
                                  const numberOfDays =
                                    props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "numberOfDays",
                                    ]);

                                  if (numberOfDays && amount) {
                                    const procedureAmount =
                                      parseFloat(numberOfDays) *
                                      parseFloat(amount);
                                    props?.form.setFieldsValue({
                                      items: {
                                        [index]: {
                                          procedureTotalAmount:
                                            procedureAmount?.toString(),
                                        },
                                      },
                                    });
                                  } else {
                                    props?.form.setFieldsValue({
                                      items: {
                                        [index]: {
                                          procedureTotalAmount: 0,
                                        },
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        {props?.form
                          .getFieldValue(["items", index, "procedureCode"])
                          ?.toLowerCase()
                          ?.includes("unspecified") ? (
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              label="PROCEDURE NAME"
                              name={[field.name, "unspecifiedProcedureName"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{ borderRadius: "5px" }}
                                placeholder="Enter Procedure Name"
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        {props?.form
                          .getFieldValue(["items", index, "procedureCode"])
                          ?.toLowerCase()
                          ?.includes("unspecified") ? (
                          <Col span={7}>
                            <Form.Item
                              {...field}
                              label="PROCEDURE AMOUNT"
                              name={[field.name, "unspecifiedProcedureAmount"]}
                              rules={[
                                { required: true, message: "Required" },
                                {
                                  pattern: /^\d+$/,
                                  message: "Only Numeric values are allowed!",
                                },
                              ]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{ borderRadius: "5px" }}
                                placeholder="Enter Procedure Amount"
                                onChange={(e) => {
                                  const amount = e.target.value.trim();
                                  const numberOfDays =
                                    props?.form.getFieldValue([
                                      "items",
                                      index,
                                      "numberOfDays",
                                    ]);

                                  if (numberOfDays && amount) {
                                    const procedureAmount =
                                      parseFloat(numberOfDays) *
                                      parseFloat(amount);
                                    props?.form.setFieldsValue({
                                      items: {
                                        [index]: {
                                          procedureTotalAmount:
                                            procedureAmount?.toString(),
                                        },
                                      },
                                    });
                                  } else {
                                    props?.form.setFieldsValue({
                                      items: {
                                        [index]: {
                                          procedureTotalAmount: 0,
                                        },
                                      },
                                    });
                                  }
                                }}
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        {props?.form.getFieldValue([
                          "items",
                          index,
                          "procedureCode",
                        ]) &&
                        JSON.parse(
                          props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ])
                        )
                          ?.strats?.toLowerCase()
                          ?.includes("y") ? (
                          <Col span={7}>
                            <Form.Item
                              {...field}
                              label="STRATS NAME"
                              name={[field.name, "stratsName"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Input
                                style={{ borderRadius: "5px" }}
                                placeholder="Enter Strats Name"
                                disabled={true}
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        {props?.form.getFieldValue([
                          "items",
                          index,
                          "procedureCode",
                        ]) &&
                        JSON.parse(
                          props?.form.getFieldValue([
                            "items",
                            index,
                            "procedureCode",
                          ])
                        )
                          ?.strats?.toLowerCase()
                          ?.includes("y") ? (
                          <Col span={8}>
                            <Form.Item
                              {...field}
                              label="STRATS OPTIONS"
                              name={[field.name, "stratOptionValue"]}
                              rules={[{ required: true, message: "Required" }]}
                              labelCol={{ span: 24 }}
                              wrapperCol={{ span: 24 }}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <Select
                                showSearch
                                defaultValue={`Select a Strats Value`}
                                options={
                                  props?.form.getFieldValue([
                                    "items",
                                    index,
                                    "procedureCode",
                                  ]) &&
                                  (props?.procedureStrats[
                                    JSON.parse(
                                      props?.form.getFieldValue([
                                        "items",
                                        index,
                                        "procedureCode",
                                      ])
                                    )?.id
                                  ]?.options?.map((option: any) => ({
                                    value: JSON.stringify(option),
                                    label: option?.stratOptionValue,
                                  })) ||
                                    [])
                                }
                              />
                            </Form.Item>
                          </Col>
                        ) : (
                          <></>
                        )}

                        <div style={{ width: "100%" }}>
                          <h4
                            style={{ display: "flex", justifyContent: "end" }}
                          >
                            Amount: ₹{" "}
                            {props?.form.getFieldValue([
                              "items",
                              index,
                              "procedureTotalAmount",
                            ]) ?? 0}
                            /-
                          </h4>
                        </div>
                      </Row>
                    );
                  })}
                {
                  <Button
                    type="dashed"
                    onClick={() => {
                      add({
                        treatmentStartDate: props.patientDetails
                          ?.visitInfoResponse?.doa
                          ? dayjs(
                              props.patientDetails?.visitInfoResponse?.doa,
                              "DD-MM-YYYY HH:mm:ss"
                            )
                          : null,
                        numberOfDays: "1",
                        accreditationStatus: props?.patientDetails
                          ?.casesResponse?.nablStatus
                          ? "NABL~NABL"
                          : props?.patientDetails?.casesResponse?.nabhStatus
                          ? "NABH~NABH"
                          : "NON NABH~NON NABH",
                        treatingDoctor: "OTHERS~OTHERS",
                        procedureReferral: "referral~REFERRAL",
                      });
                    }}
                    style={{
                      background: "#008B8B",
                      color: "white",
                      boxShadow: "0px 2px 8px 0px #00000040",
                      border: "1px solid #C4C4C4",
                    }}
                  >
                    Add Procedure
                  </Button>
                }
              </div>
            )}
          </Form.List>
          <div style={{ width: "100%", marginBottom: "0.8rem" }}>
            <h4 style={{ display: "flex", justifyContent: "end" }}>
              Total Amount: ₹ {totalProcedureAmount}/-
            </h4>
          </div>
        </Form>
      </div>
      <ConfirmModals
        setIsModalOpen={props?.setIsModalOpen}
        isModalOpen={props?.isModalOpen}
        handleOk={handleConfirm}
        handleCancel={props?.handleCancel}
        text={"ARE YOU SURE YOU WANT TO DELETE THIS PROCEDURE"}
      />
    </div>
  );
};

export default ResubmissionProcedureCghs;
